
//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getRidingPeriod, getLivraison } from "../../../../../../store/selectors.js"; //global state : shopping state
import { livraisonSlice } from "../../../../../../store/livraisonSlice.js";

// Form controll with yup
import * as yup from 'yup' // importing functions from yup library


import { useState, useEffect } from 'react';

//MUI Components
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';


// utils function to get duration object
import calculDuree from '../../../../../../utils/calcul_duree.js'

//list of accepted sectors
const zoneLivraison = ["Carreyre", "Longarisse", "Le Porge", "Lacanau Ville", "Talaris", "Le Huga", "Pitrot", "Brach", "Saumos", "La Grande Escoure", "autres"];



function AdresseLivraison({ idSpot }) {
    const [secteur, setSecteur] = useState('') // useState to store secteur
    const [adresse, setAdresse] = useState('') // useState to store adresse
    const [comp, setComp] = useState('') // useState to store adresse
    const [formValid, setFormValid] = useState(false) // useState to store validity of form
    const dispatch = useDispatch();
    const globalLivraison = useSelector(getLivraison) //global state : Livraison

    //UseEffect : validateForm when secteur or addresse change
    useEffect(() => {
        setSecteur(globalLivraison.secteur || "autres");
        setAdresse(globalLivraison.adresse || "adresse");
        setComp(globalLivraison.comp || "-");

    }, [])

    //UseEffect : validateForm when secteur or addresse change
    useEffect(() => {
        validateForm();
    }, [adresse, secteur])

    //UseEffect : modif global state on valid form change
    useEffect(() => {
        //send livraison infos to global state
        dispatch(livraisonSlice.actions.setLivraison({ valid: true, secteur, adresse, comp })); //update global state (livraison)

    }, [formValid, adresse, secteur, comp])

    // defining yup schema to validate our form
    const adresseSchema = yup.object().shape({
        secteur: yup.string().required(),
        adresse: yup.string().required(),
    })

    // Function which will validate the input data whenever submit button is clicked.
    async function validateForm() {
        // creating a form data object
        let dataObject = {
            secteur: secteur,
            adresse: adresse,
        }
        // validating this dataObject concerning Yup userSchema

        const isValid = await adresseSchema.isValid(dataObject)

        if (isValid) {
            //console.log('Form is Valid');
            setFormValid(true);
        } else {
            //console.log('Form is Invalid')
            setFormValid(false);
        }

    }



    const period = useSelector(getRidingPeriod) //global state : shopping step

    let tooShort = false;
    let duration = calculDuree(period); // get number of days, weeks, hours...
    tooShort = (duration.semaine === 0 && duration.bimensuel === 0 && duration.jour < 3);


    return (
        <div className="adresse-livraison">

            <div className="adresse-livraison-bloc">
                <FormControl fullWidth className="adresse-livraison-bloc">
                    <InputLabel id="select-zone-livraion-label">Secteur de livraison</InputLabel>
                    <Select
                        required
                        labelId="select-zone-livraion-label"
                        id="selectSecteurLivraion"
                        value={secteur}
                        label="votre secteur de livraison"
                        onChange={(e) => {
                            setSecteur(e.target.value);
                        }}

                    >
                        {zoneLivraison.map((secteur) => <MenuItem key={secteur} value={secteur}>{secteur}</MenuItem>)}
                    </Select>
                </FormControl>
            </div>
            <div className="adresse-livraison-bloc">
                <TextField fullWidth className="adresse-livraison-bloc"
                    id="adresseLivraion"
                    label="Votre adresse de vacances :"
                    value={adresse}
                    onChange={(e) => {
                        setAdresse(e.target.value);
                    }}
                />
            </div>
            <div className="adresse-livraison-bloc">
                <TextField fullWidth
                    id="textfield-adresse-livraison-2"
                    label="infos complémentaires :"
                    placeholder="numéro emplacement, appartement..."
                    value={comp}
                    onChange={(e) => {
                        setComp(e.target.value);
                    }}
                />
            </div>


        </div>

    )
}




export default AdresseLivraison